import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ServicioSection } from './components/ServicioSection';
import { Testimonios } from './components/Testimonios';
import { Contacto } from './components/Contacto';
import { Footer } from './components/Footer';
import { TawkToWidget } from './components/TawkToWidget';
import { servicios } from './data/servicios';
export function App() {
  return <div className="min-h-screen w-full bg-[#0D0D0D] font-sans" data-id="element-0" data-mp="2rlf5yrr73m2b">
      <Header data-id="element-1" data-mp="2mmltn2nna13q" />
      <main data-id="element-2" data-mp="2mn5ccll4ctit">
        <Hero data-id="element-3" data-mp="2mndryl8mmcxp" />
        {servicios.map(servicio => <ServicioSection key={servicio.id} servicio={servicio} data-id="element-4" data-mp="31b8jvzet8d9q" />)}
        <Testimonios data-id="element-5" data-mp="2wk0a329kipw1" />
        <Contacto data-id="element-6" data-mp="2wjgpfdsj9neb" />
      </main>
      <Footer data-id="element-7" data-mp="2wj8g1vvmd07v" />
      <TawkToWidget data-id="element-8" data-mp="2wip7h5ruzo6i" />
    </div>;
}